import { createFileRoute } from "@tanstack/react-router";
import { AppDetail } from "@/components/connectors/app-detail";
import { OwnerWorkspaceGate } from "@/components/owner-workspace-gate";

/**
 * A first-party app's instruction page: `/connectors/app/{id}`.
 *
 * Static — the id names a catalog entry in `app-catalog`, not a row in any
 * table. It gets a real route rather than a modal so the Mac app's setup steps
 * are a link someone can paste to a colleague.
 */
export const Route = createFileRoute("/$owner/connectors/app/$appId")({
	component: AppDetailPage,
});

function AppDetailPage() {
	const { owner, appId } = Route.useParams();
	return (
		<OwnerWorkspaceGate owner={owner}>
			{({ ownerSlug }) => <AppDetail ownerSlug={ownerSlug} appId={appId} />}
		</OwnerWorkspaceGate>
	);
}
